import React from "react";
import { Container } from "./styles";
export var PaymentPercentTag = function (_a) {
    var percent = _a.percent, text = _a.text, width = _a.width;
    var getColor = function (startColor, middleColor, endColor) {
        var r, g, b;
        if (percent < 50) {
            // Transição de vermelho para amarelo
            r = Math.floor(startColor[0] + (middleColor[0] - startColor[0]) * (percent / 50));
            g = Math.floor(startColor[1] + (middleColor[1] - startColor[1]) * (percent / 50));
            b = Math.floor(startColor[2] + (middleColor[2] - startColor[2]) * (percent / 50));
        }
        else {
            // Transição de amarelo para azul
            r = Math.floor(middleColor[0] + (endColor[0] - middleColor[0]) * ((percent - 50) / 50));
            g = Math.floor(middleColor[1] + (endColor[1] - middleColor[1]) * ((percent - 50) / 50));
            b = Math.floor(middleColor[2] + (endColor[2] - middleColor[2]) * ((percent - 50) / 50));
        }
        return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
    };
    // Cores para o fundo e o texto
    var backgroundColor = getColor([255, 240, 242], [255, 255, 192], [236, 255, 253]);
    var textColor = getColor([255, 44, 61], [227, 163, 0], [59, 210, 193]);
    return (React.createElement(Container, { percent: percent, color: backgroundColor, textColor: textColor, width: width },
        React.createElement("span", null,
            percent,
            "% ",
            text || "fechada")));
};
//# sourceMappingURL=index.js.map